<h1 mat-dialog-title>{{('main.' + data.type) | translate}}</h1>
<div mat-dialog-content>
  <p>{{data.text}}</p>
  <mat-form-field style="width:100%">
    <textarea placeholder="Leave a comment" matInput  [(ngModel)]="comment"></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="send(null)">Cancel</button>
  <button mat-button cdkFocusInitial [disabled]="comment.length === 0" (click)="send(comment)">Send to user</button>
</div>
